
import React, { useState } from 'react';
import { Row, Col, Button, Card as BSCard } from 'reactstrap';

import DataStore from '../base/plumbing/DataStore';
import { getType } from '../base/data/DataClass';
import C from '../C';

import { Card } from '../base/components/CardAccordion';
import PropControl from '../base/components/PropControl';
import KWorkflow from './KWorkflow';
import NGO from '../base/data/NGO';

/**
 * @param {Object} p
 * @param {?String} p.workflow KWorkflow
 * @param children add additional elements to Card if desired
 * @param entity {Advert|Publisher}
 * @param path {String[]} path to entity
 */
function BrandingEditor({children, entity, path, workflow, className = 'branding-editor', ...other}) {
	let b = entity.branding;
	let bpath = path.concat('branding');
	// HACK: NGO's data structure is different from e.g. Advert or Agency. It doesn't use a separate Branding object.
	if (NGO.isa(entity)) {
		bpath = path;	
	}
	const logo = b && b.logo ? <img height={32} src={b.logo} /> : null;
	return (
		<Card title={<>Branding {logo}</>} className={className} {...other}>
			{workflow !== KWorkflow.DesignPostEngagement &&
				<Row>
					<Col sm="5">
						<PropControl label="Logo" type="imgUpload" item={b} prop="logo" path={bpath} version="standard" required cacheControls
							help="Recommended format: .svg (which can scale nicely without pixelation). Otherwise, we recommend 256px square .png or .jpg.  When you drag-and-drop an image file into the appropriate uploader field, your image will be uploaded and preserved in its original state as well as optimised by ImageMagick in an attempt to strip un-needed bytes off of the image without a major quality sacrifice.  This optimised version of your image is what you will see on your rendered adunit."
						/>
					</Col>
					<Col sm="5">
						<PropControl label="White Silhouette Logo" type="imgUpload" item={b} path={bpath} prop="logo_white" bg={(b && b.color) || "transparent"} version="standard" cacheControls />
					</Col>
					<Col sm="2">
						<PropControl label="Brand Colour" item={b} path={bpath} type="color" prop="color" />
					</Col>
				</Row>
			}

			{workflow === KWorkflow.ImpactHub && // HACK most of our objects dont use social media, so hide these controls
				<Row>
					<Col sm="6" md="4" lg="3"><PropControl label="Twitter Link" type="url" item={b} path={bpath} prop="tw_url" /></Col>
					<Col sm="6" md="4" lg="3"><PropControl label="Facebook Link" type="url" item={b} path={bpath} prop="fb_url" /></Col>
					<Col sm="6" md="4" lg="3"><PropControl label="Instagram Link" type="url" item={b} path={bpath} prop="insta_url" /></Col>
					<Col sm="6" md="4" lg="3"><PropControl label="Youtube Link" type="url" item={b} path={bpath} prop="yt_url" /></Col>
				</Row>
			}
			{ children }
		</Card>
	);
}

export default BrandingEditor;
